"use client";

import { c as _c } from "react/compiler-runtime";
import DialogModal from "./detail-dialog/DetailDialog";
import SheetModal from "./DetailSheet";
import { useDialogDetailsActions, useDialogDetailsModalState } from "./DialogProvider";
import useMetadata from "@/hooks/useMetadata";
export default function DetailDialogContainer() {
  const $ = _c(6);
  const {
    openModalId,
    openModal,
    isMobile
  } = useDialogDetailsModalState();
  const {
    handleMinimizeDialog,
    handleOnOpenChange,
    handleMaximizeDialog,
    handleDismissDialog
  } = useDialogDetailsActions();
  useMetadata(openModalId as string || openModalId, openModal);
  let t0;
  if ($[0] !== handleDismissDialog || $[1] !== handleMaximizeDialog || $[2] !== handleMinimizeDialog || $[3] !== handleOnOpenChange || $[4] !== isMobile) {
    t0 = isMobile ? <SheetModal data-sentry-element="SheetModal" data-sentry-component="DetailDialogContainer" data-sentry-source-file="DialogContainer.tsx" /> : <DialogModal handleMaximizeDialog={handleMaximizeDialog} minimizeDialog={handleMinimizeDialog} handleOnOpenChange={handleOnOpenChange} handleDismissDialog={handleDismissDialog} data-sentry-element="DialogModal" data-sentry-component="DetailDialogContainer" data-sentry-source-file="DialogContainer.tsx" />;
    $[0] = handleDismissDialog;
    $[1] = handleMaximizeDialog;
    $[2] = handleMinimizeDialog;
    $[3] = handleOnOpenChange;
    $[4] = isMobile;
    $[5] = t0;
  } else {
    t0 = $[5];
  }
  return t0;
}